<template>
  <div>
    <el-form ref="form" :model="formData" label-width="80px">
      <el-form-item label="名称">
        <el-input type="textarea" v-model ="formData.text"></el-input>
      </el-form-item>

      <el-form-item label="显示方式">
        <el-radio-group v-model="formData.isshow">
          <el-radio :label=1>显示</el-radio>
          <el-radio :label=0>隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
        <el-form-item label="回调">
            <el-select ref="gw" v-model="formData.callback" placeholder="请选择" @change="selectCb">
                <el-option
                        v-for="(item,index) in options"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.vc_type"
                ></el-option>

            </el-select>
        </el-form-item>
        <el-form-item  label="更新状态">
            <el-input type="textarea" v-model="formData.upstate"></el-input>
        </el-form-item>

    </el-form>
  </div>
</template>
<script>
import * as flowUtil from '@/utils/logicFlowJs.js';
export default {
  name: '',
  props: {
    nodeData: Object,
    setData: Object,
    lf: Object || String,
  },
  watch: {
    formData: {
      handler(n, o) {
        const nodeData = this.$props.nodeData
        this.$props.lf.setProperties(nodeData.id, n);
        this.$props.lf.updateText(nodeData.id, n.text);
      },
      deep:true// 深度监听父组件传过来对象变化
    },
  },
  mounted() {
    const { properties, text } = this.$props.nodeData
    if (properties) {
      this.$data.formData = Object.assign({}, this.$data.formData, properties)
    }

    if (text && text.value) {
      this.$data.formData.text = text.value
    }
    this.flowSetData= this.$props.setData;
    this.loadCb();

  },
  data() {
    return {
      formData: {
        text: '等待',
        isshow:1,
        callback: '',
        upstate:'',

      },
      options:[],
      flowSetData:{},
    }
  },
  methods: {
      opchange(){
          this.$data.formData.callback="";
      },
      selectCb(){
          this.$nextTick(()=>{
              let t=this.$refs.gw.selected.label;
              this.$data.formData.text=t;
          })
      },
      //loadCallBack
      async loadCb() {
          let param = {"table":this.flowSetData.mainTable,"sptype":this.flowSetData.vc_sptype};
          let res = await flowUtil.getCallBackList(param);
          if (res.code == 1) {
              this.options= res.data;
          } else {
              this.$message.error(res.message);
          }
      },
  }
}
</script>
<style scoped>
</style>
